module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0077.35dd5d4d.jpg";